import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

const steps = [
  { number: '1', title: 'Anfrage starten', text: 'Telefonisch, per E-Mail oder über den Baustellen-Assistenten.' },
  { number: '2', title: 'Eckdaten prüfen', text: 'Menge, Adresse, Zufahrt, Pumpweg und Termin werden konkretisiert.' },
  { number: '3', title: 'Einsatz fixieren', text: 'Beton, Fahrzeug und Pumpe werden passend zur Baustelle eingeteilt.' },
  { number: '4', title: 'Einbringen', text: 'Der Beton kommt zur richtigen Zeit an die richtige Stelle.' },
];

function ProcessSection() {
  return (
    <section id="ablauf" className="py-12 sm:py-16 md:py-28 border-t border-ink/10">
      <div className="container-site mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="Ablauf"
            title="Vom Erstkontakt zur sauberen Einbringung."
            compact
          />
        </Reveal>

        <div className="relative grid md:grid-cols-4 gap-4 mt-8">
          <div
            className="hidden md:block absolute top-[calc(1.35rem+19px)] left-8 right-8 h-px"
            aria-hidden="true"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(7,95,128,0.28), transparent)' }}
          />
          {steps.map((step, index) => (
            <Reveal key={step.number} delay={index * 100}>
              <article className="relative p-5 rounded-card border border-ink/10 bg-white/90 shadow-card min-h-[200px] sm:min-h-[240px] transition-all hover:-translate-y-1 hover:border-signal/40 hover:shadow-[0_18px_42px_rgba(13,37,46,0.12)]">
                <span className="grid place-items-center w-10 h-10 rounded-full bg-gradient-to-br from-signal to-signal-light text-ink font-extrabold shadow-[0_10px_24px_rgba(46,179,231,0.24)] mb-4">
                  {step.number}
                </span>
                <h3 className="text-base sm:text-lg font-extrabold mb-2">{step.title}</h3>
                <p className="text-ink-soft text-sm sm:text-base leading-relaxed">{step.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
